
export default {
  name: 'AppProgressBar',
  props: {
    value: { type: Number, required: true },
    max: { type: Number, required: true }
  }
};
